import { prefixerT } from '.'

export const ROUTE_INGRESO_BODEGA = prefixerT('ingreso-bodega')
export const ROUTE_EGRESO_BODEGA = prefixerT('egreso-bodega')
export const ROUTE_CONFIRMACION_TRANSFERENCIA = prefixerT('confirmacion-transferencia')
export const ROUTE_GESTION_SOLICITUDES_ITEMS = prefixerT('gestion-solicitudes-items')
export const ROUTE_APROBACION_SOLICITUD_ITEM = prefixerT('aprobacion-solicitud-item')
export const ROUTE_APROBACION_MARCA = prefixerT('aprobacion-marca')
export const ROUTE_CREAR_SOLICITUD_ITEM = prefixerT('crear-solicitud-item')
export const ROUTE_APROBACION_CONTABLE_ITEMS = prefixerT('aprobacion-contable-items')
export const ROUTE_APROBACION_TRIBUTARIA_ITEMS = prefixerT('aprobacion-tributaria-items')
export const ROUTE_CREAR_SOLICITUD_MARCA = prefixerT('crear-solicitud-marca')
export const ROUTE_DEVOLUCION = prefixerT('devolucion')
export const ROUTE_GESTION_SOLICITUD_DEVOLUCION = prefixerT('gestion-solicitud-devolucion')
export const ROUTE_SOLICITUD_DEVOLUCION = prefixerT('solicitud-devolucion')
export const ROUTE_APROBACION_SOLICITUD_DEVOLUCION = prefixerT('aprobacion-solicitud-devolucion')
export const ROUTE_CONSUMO = prefixerT('consumo')
export const ROUTE_GESTION_SOLICITUD_CONSUMO = prefixerT('gestion-solicitud-consumo')
export const ROUTE_SOLICITUD_CONSUMO = prefixerT('solicitud-consumo')
export const ROUTE_APROBACION_SOLICITUD_CONSUMO = prefixerT('aprobacion-solicitud-consumo')
export const ROUTE_TRANSFERENCIA = prefixerT('transferencia')
export const ROUTE_GESTION_SOLICITUD_TRANSFERENCIA = prefixerT('gestion-solicitud-transferencia')
export const ROUTE_SOLICITUD_TRANSFERENCIA = prefixerT('solicitud-transferencia')
export const ROUTE_APROBACION_SOLICITUD_TRANSFERENCIA = prefixerT('aprobacion-solicitud-transferencia')
export const ROUTE_ORDEN_PEDIDO = prefixerT('orden-pedido')
export const ROUTE_GESTION_ORDEN_PEDIDO = prefixerT('gestion-orden-pedido')
export const ROUTE_CREAR_ORDEN_PEDIDO = prefixerT('crear-orden-pedido')
export const ROUTE_APROBACION_ORDEN_PEDIDO = prefixerT('aprobacion-orden-pedido')
